import { MarketTemplate } from "../../data";
import { prepareEmptyMarket, valueOrDefault } from "../../helpers";
export const getAvailableOutrightMarket = (eventId, markets) => {
    var _a;
    return valueOrDefault(markets[0], prepareEmptyMarket(eventId, valueOrDefault((_a = markets[0]) === null || _a === void 0 ? void 0 : _a.marketType.id, ""), MarketTemplate.ThreeBox, 0));
};
//# sourceMappingURL=getAvailableOutrightMarket.js.map